"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mql = void 0;
var MqlParser_1 = require("./MqlParser");
var execNode_1 = require("./execNode");
var suggest_1 = require("./suggest");
exports.Mql = Object.freeze({
    tokens: {
        joiners: ['AND', 'OR'],
        operators: ['=', '<>', '>', '<', '>=', '<=', 'MATCHES', 'LIKE'],
    },
    compile: function (query) {
        var ast = MqlParser_1.MqlParser.parse(query);
        var test = function (scope, item) { return !!(0, execNode_1.execNode)(scope, ast, item); };
        var filter = function (scope, items) { return items.filter(function (elmt) { return test(scope, elmt); }); };
        return Object.freeze({ source: query, test: test, filter: filter });
    },
    test: function (scope, query, item) {
        var ast = MqlParser_1.MqlParser.parse(query);
        return (0, execNode_1.execNode)(scope, ast, item);
    },
    filter: function (scope, query, items) {
        var ast = MqlParser_1.MqlParser.parse(query);
        return items.filter(function (elmt) { return (0, execNode_1.execNode)(scope, ast, elmt); });
    },
    suggest: suggest_1.suggest,
});
